import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    wrapper: {
      width: 872,
      margin: "0 auto",
      padding: theme.spacing(12, 0),
    },
    tableTitle: {
      color: theme.gray800,
      fontWeight: 400,
      marginBottom: theme.spacing(6),
    },
    link: {
      color: theme.primary500,
      fontWeight: 500,
      fontSize: 15,
      textTransform: "uppercase",
      textDecoration: "none",
    },
    linkWrapper: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    nameTdWrapper: {
      display: "flex",
      alignItems: "center",
      maxWidth: "100%",
    },
    name: {
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      marginRight: theme.spacing(4),
    },
    icon: {
      marginRight: theme.spacing(4),
      minWidth: 20,
      minHeight: 20,
    },
    buttonWrapper: {
      marginTop: theme.spacing(12),
      display: "flex",
      justifyContent: "flex-end",
    },
    warnIcon: {
      color: theme.orange500,
      marginRight: theme.spacing(4),
      minWidth: 20,
      minHeight: 20,
    },
    errorIcon: {
      color: theme.red500,
    },
    simulateInfo: {
      fontSize: 14,
      marginTop: theme.spacing(6),
    },
  }),
);
